export default "__VITE_ASSET__eda2721e__"